<template>
  <div class="app-container">
    <el-card class="filter-container">
      <el-form
          size="medium"
          :inline="true"
      >
        <el-row>
          <el-col :span="21">
            <el-input
                placeholder="搜索关键词：昵称 / 姓名"
                prefix-icon="el-icon-search"
                v-model="keyWord">
            </el-input>
          </el-col>
          <el-col :span="1" style="padding-left: 10px">
            <el-button icon="el-icon-search" circle @click="getUserDiskInfoList()"></el-button>
          </el-col>
          <el-col :span="2" style="padding-left: 5px">
            <el-button type="primary" @click="openDefaultCapacitySettingDialog()">容量设置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-table
        v-loading="loading"
        :data="userDiskInfoList"
        border
        style="width: 100%">
      <el-table-column
          prop="userId"
          label="用户ID"
          width="110"
      >
      </el-table-column>
      <el-table-column
          label="头像"
          width="80"
      >
        <template slot-scope="scope">
          <el-avatar :key="scope.row.avatar" :size="50"
                     :src="config.RESOURCES+scope.row.avatar"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="nickname"
          label="昵称"
      >
      </el-table-column>
      <el-table-column
          label="姓名"
          width="120"
      >
        <template slot-scope="scope">

          {{ scope.row.firstName === null ? (scope.row.lastName === null ? '' : scope.row.lastName) : (scope.row.lastName === null ? scope.row.firstName : scope.row.firstName + scope.row.lastName) }}
        </template>
      </el-table-column>
      <el-table-column
          label="已使用容量"
      >
        <template slot-scope="scope">
          <div style="display:flex;flex-direction: row">
            <el-progress width="55" type="circle"
                         :percentage="(100*scope.row.usedCapacity/scope.row.allCapacity).toFixed(2)"></el-progress>
            <div style="padding-top:15px;padding-left:10px">{{ getCapacityInfo(scope.row.usedCapacity) }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          label="分配容量"
      >
        <template slot-scope="scope">
          {{ getCapacityInfo(scope.row.allCapacity) }}
        </template>
      </el-table-column>
      <el-table-column
          fixed="right"
          label="容量管理"
          width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openCapacitySettingDialog(scope.row)">管理</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-show="totalCount > pageSize" class="pagination">
      <el-pagination
          v-show="userDiskInfoList.length > 0"
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="totalCount"
          :current-page="currentPage"
          @current-change="userDiskInfoList"
      />
    </div>
    <p style="color: dimgrey">共{{ totalCount }}条</p>
    <el-dialog
        title="管理用户容量"
        :visible.sync="openCapacityDialog"
        width="30%"
        center>
      <el-alert
          :title="capacitySettingTip"
          type="warning"
          style="margin-bottom: 15px"
          :closable="false"
          show-icon>
      </el-alert>
      <el-form ref="form" label-width="120px">
        <el-form-item label="容量设置（GB）">
          <el-slider
              :min="1"
              :max="50"
              v-model="tempCapacity"
              show-input>
          </el-slider>
        </el-form-item>
        <div></div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openCapacityDialog = false">取 消</el-button>
        <el-button type="primary" @click="resetUserCapacity()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="管理用户默认容量"
        :visible.sync="openDefaultCapacityDialog"
        width="30%"
        center>
      <el-alert
          :title="defaultCapacityTip"
          type="warning"
          style="margin-bottom: 15px"
          :closable="false"
          show-icon>
      </el-alert>
      <el-form ref="form" label-width="120px">
        <el-form-item label="默认容量（GB）">
          <div class="block">
            <el-slider
                :min="1"
                :max="50"
                v-model="tempDefaultCapacity"
                show-input>
            </el-slider>
          </div>
        </el-form-item>
        <div></div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openDefaultCapacityDialog = false">取 消</el-button>
        <el-button type="primary" @click="resetDefultCapacity()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getDiskConfig,
  setDiskConfig,
  resetUserCapacity,
  getUserDiskInfoList
} from "@/api/system/netDisk/netDisk";
import config from "@/utils/config";

export default {
  computed: {
    config() {
      return config
    }
  },
  components: {},
  created() {
    this.getDiskConfig()
    this.getUserDiskInfoList()
  },
  data() {
    return {
      loading: false,  // 加载中
      keyWord: '',     // 搜索关键词
      totalCount: 0,  // 总数
      currentPage: 1, // 当前页码
      pageSize: 20,   // 每页条数
      userDiskInfoList: [], // 用户网盘容量列表
      diskConfig: {}, //网盘容量全局配置defaultUserCapacity
      openCapacityDialog: false,
      openDefaultCapacityDialog: false,
      userCapacity: {},
      tempCapacity: 0,
      tempDefaultCapacity: 0,
      capacitySettingTip: '',
      defaultCapacityTip: '请管理用户注册后默认拥有的最大容量',
      capacityTip: '单位换算：'
    }
  },
  methods: {
    calculateDanwei(danwei) {
      this.capacityTip = '单位换算：' + danwei * 1024 + 'KB' + ' / ' + danwei + 'MB' + ' / ' + (danwei / 1024).toFixed(2) + 'GB'
    },
    openCapacitySettingDialog(row) {
      this.userCapacity = row
      this.capacitySettingTip = '设置要求:不能低于已使用容量' + this.getCapacityInfo(this.userCapacity.usedCapacity)
      this.tempCapacity = this.userCapacity.allCapacity / 1024 / 1024
      this.openCapacityDialog = true
    },
    openDefaultCapacitySettingDialog() {
      this.tempDefaultCapacity = this.diskConfig.defaultUserCapacity / 1024 /1024
      this.openDefaultCapacityDialog = true
    },
    resetUserCapacity() {
      if (this.tempCapacity <= 0) {
        this.$message.error('请设置正确的容量值');
      } else if (this.tempCapacity * 1024 *1024 < this.userCapacity.usedCapacity) {
        this.$message.error('容量值太低了！');
      } else {
        let param={userId: this.userCapacity.userId, allCapacity: this.tempCapacity * 1024 * 1024}
        const data = {
          ...param
        };
        resetUserCapacity(data).then((res) => {
          if (res.code === 200) {
            this.getUserDiskInfoList()
            this.openCapacityDialog = false
            this.$message({
              message: '设置成功',
              type: 'success'
            });
          }
        })
      }
    },
    resetDefultCapacity() {
      if (this.tempDefaultCapacity <= 0) {
        this.$message.error('请设置正确的容量值');
      } else {
        setDiskConfig({
          defaultUserCapacity: this.tempDefaultCapacity * 1024 *1024,
          deviceConfigId: this.diskConfig.deviceConfigId
        }).then((res) => {
          if (res.code === 200) {
            this.openDefaultCapacityDialog = false
            this.getUserDiskInfoList()
            this.getDiskConfig()
            this.$message({
              message: '设置成功',
              type: 'success'
            });
          }
        })
      }
    },
    getDiskConfig() {
      getDiskConfig().then((res) => {
        if (res.code === 200) {
          this.diskConfig = res.data
        }
      })
    },
    // 获取用户网盘容量列表
    getUserDiskInfoList() {
      this.loading = true;
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      if (this.keyWord !== '') {
        params.keyWord = this.keyWord
      }
      getUserDiskInfoList(params).then((res) => {
        if (res.code === 200) {
          this.userDiskInfoList = res.data.rows
          this.totalCount = res.data.total
        }
        this.loading = false
      })
    },
    getCapacityInfo(num) {
      if (num < 1024) {
        return num + 'KB'
      } else if (num < 1024 * 1024) {
        return (num / 1024).toFixed(2) + 'MB'
      } else if (num < 1024 * 1024 * 1024) {
        return (num / 1024 / 1024).toFixed(2) + 'GB'
      }
    }
  }
}
</script>
<style scoped>

</style>
